import React from "react";

export default function Widerruf() {
  return (
    <main className="mx-auto max-w-4xl px-6 py-12 text-gray-800 leading-relaxed">
      <h1 className="text-2xl font-bold mb-6">Widerrufsbelehrung</h1>

      <h2 className="text-xl font-semibold mt-8 mb-3">1. Widerrufsrecht</h2>
      <p>
        Verbraucher haben das Recht, binnen 14 Tagen ohne Angabe von Gründen
        diesen Vertrag zu widerrufen.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">2. Frist</h2>
      <p>
        Die Widerrufsfrist beträgt 14 Tage ab dem Tag des Vertragsabschlusses.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">3. Ausübung</h2>
      <p>
        Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (<strong>GVSI Clean & Care</strong>)
        mittels einer
        eindeutigen Erklärung (z. B. per Brief oder E-Mail) über Ihren Entschluss informieren.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">4. Folgen</h2>
      <p>
        Im Falle des Widerrufs erstatten wir alle Zahlungen binnen 14 Tagen zurück.
        Haben Sie verlangt, dass die Dienstleistung während der Widerrufsfrist beginnen soll,
        so haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der bis zum Widerruf
        erbrachten Leistungen entspricht.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">5. Ausschluss</h2>
      <p>
        Das Widerrufsrecht besteht nicht, wenn die Dienstleistung vollständig erbracht wurde
        und Sie ausdrücklich zugestimmt haben, dass wir vor Ablauf der Widerrufsfrist beginnen.
      </p>
    </main>
  );
}
